
import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  GetExportFileRes,
  MarketingActivityExportReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useExport() {
  class Export<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Export
     * @name ExportFileControllerGetExportFile
     * @summary Get export file download link
     * @request GET:/api3/export/file/{id}
     * @secure
     * @response `200` `GetExportFileRes`
     * @response `400` `BaseErrorResponse`
     */
    exportFileControllerGetExportFile = (id: number, params: RequestParams = {}) =>
      this.request<GetExportFileRes, BaseErrorResponse>({
        path: `/api3/export/file/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Export
     * @name MarketingActivityExportControllerMarketingActivityExport
     * @summary Launch export marketing activity
     * @request POST:/api3/export/marketing-activity
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    marketingActivityExportControllerMarketingActivityExport = (
      query: {
        /**
         * Filter field
         * @example "s.account_id"
         */
        field: string;
        /** @example "=" */
        operation: string;
        /** @example 1 */
        value: object;
      } | undefined,
      data: MarketingActivityExportReq,
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: '/api3/export/marketing-activity',
        method: 'POST',
        query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Export();
}
